<template>
  <div class="password-information">
    Минимальная длина: 8 символов
  </div>
</template>

<script>
export default {
  name: 'PasswordInfo',
};
</script>

<style scoped>
.password-information {
  margin: 10px 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #707683;
}
label ~ .password-information {
  margin-top: -10px;
  margin-bottom: 20px;
}
</style>
